<ion-text color="dark">
  <h3 class="product-grid-title">{{ node?.title }}</h3>
</ion-text>

<ion-grid class="ion-justify-content-start">
  <ion-row>
    <ion-col size="6" [sizeMd]="columnCount" *ngFor="let item of node?.items; let index = index">
      <ion-card (click)="storeLink(item)">
        <div class="ion-card-img ion-text-center">
          <app-img-format *ngIf="item.img?.url" [src]="item.img?.url" [aspectRatio]="'1:1'"
            [disableLazyLoad]="true"></app-img-format>
        </div>
        <ion-card-header>
          <ion-card-title [innerHtml]="item.store"></ion-card-title>
          <ion-card-subtitle [innerHtml]="item.label"></ion-card-subtitle>
        </ion-card-header>
        <ion-card-content> R{{ item.price }} </ion-card-content>
      </ion-card>
    </ion-col>
  </ion-row>
</ion-grid>